
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-4 text-center">
      <h1 className="text-4xl font-bold mb-4">404</h1>
      <h2 className="text-2xl font-semibold mb-6">Page Not Found</h2>
      <p className="mb-8 text-gray-600 max-w-md">
        The page you're looking for doesn't exist or has been moved.
      </p>
      <Button 
        onClick={() => navigate('/dashboard')} 
        className="mb-4"
      >
        Go to Dashboard
      </Button>
      <Button 
        onClick={() => navigate(-1)} 
        variant="outline"
      >
        Go Back
      </Button>
    </div>
  );
};

export default NotFound;
